import {useLocalStorage} from './useLocalStorage';

const getNowInSeconds = () => new Date().getTime() / 1000;

const FIVE_MINUTES_IN_SECONDS = 300;

export const useMFAError = () => {
  const now = getNowInSeconds();
  const [lastLoaded, setLastLoaded] = useLocalStorage<number | null>(
    'last-mfa-error-reloaded',
    null
  );
  const mfaError = () => {
    if (!lastLoaded) {
      window.location.reload();
      setLastLoaded(getNowInSeconds());
    } else if (now - lastLoaded >= FIVE_MINUTES_IN_SECONDS) {
      // this will authenticate the user again
      window.location.reload();
    }
  };
  return {
    mfaError,
  };
};
